/**
 * Workspace API key scopes — mirrors backend src/api-keys/api-key-scopes.ts.
 * These are scoped-key grants, not workspace/project role permissions.
 */

export const ApiKeyScopes = {
  PROJECTS_READ: "projects:read",
  PROJECTS_CREATE: "projects:create",
  PROJECTS_UPDATE: "projects:update",
  PROJECTS_ARCHIVE: "projects:archive",
  PROJECTS_DELETE: "projects:delete",
  PROJECTS_EXPORT: "projects:export",
  SCREENPLAY_UPLOAD: "screenplay:upload",
  SCREENPLAY_EDIT: "screenplay:edit",
  SCREENPLAY_LOCK: "screenplay:lock",
  SCREENPLAY_BREAKDOWN: "screenplay:breakdown",
  SCREENPLAY_SHARE_LINKS: "screenplay:share_links",
  BREAKDOWN_RERUN: "breakdown:rerun",
  CHARACTERS_READ: "characters:read",
  CHARACTERS_EDIT: "characters:edit",
  CHARACTERS_RERUN: "characters:rerun",
  ACTORS_READ: "actors:read",
  ACTORS_EDIT: "actors:edit",
  SCHEDULING_READ: "scheduling:read",
  SCHEDULING_EDIT: "scheduling:edit",
  SCHEDULING_RERUN: "scheduling:rerun",
  BUDGETING_READ: "budgeting:read",
  BUDGETING_EDIT: "budgeting:edit",
  BUDGETING_RERUN: "budgeting:rerun",
  COVERAGE_READ: "coverage:read",
  COVERAGE_EDIT: "coverage:edit",
  COVERAGE_RERUN: "coverage:rerun",
  COMMENTS_CREATE: "comments:create",
  COMMENTS_RESOLVE: "comments:resolve",
  WORKSPACE_READ: "workspace:read",
  WORKSPACE_MEMBERS_READ: "workspace:members:read",
  WORKSPACE_ACTIVITY_READ: "workspace:activity:read",
} as const;

export type ApiKeyScopeValue = (typeof ApiKeyScopes)[keyof typeof ApiKeyScopes];

/** Scopes selectable in the API Keys UI (excludes comments). */
export const API_KEY_SCOPE_VALUES = [
  ApiKeyScopes.PROJECTS_READ,
  ApiKeyScopes.PROJECTS_CREATE,
  ApiKeyScopes.PROJECTS_UPDATE,
  ApiKeyScopes.PROJECTS_ARCHIVE,
  ApiKeyScopes.PROJECTS_DELETE,
  ApiKeyScopes.PROJECTS_EXPORT,
  ApiKeyScopes.SCREENPLAY_UPLOAD,
  ApiKeyScopes.SCREENPLAY_EDIT,
  ApiKeyScopes.SCREENPLAY_LOCK,
  ApiKeyScopes.SCREENPLAY_BREAKDOWN,
  ApiKeyScopes.SCREENPLAY_SHARE_LINKS,
  ApiKeyScopes.BREAKDOWN_RERUN,
  ApiKeyScopes.CHARACTERS_READ,
  ApiKeyScopes.CHARACTERS_EDIT,
  ApiKeyScopes.CHARACTERS_RERUN,
  ApiKeyScopes.ACTORS_READ,
  ApiKeyScopes.ACTORS_EDIT,
  ApiKeyScopes.SCHEDULING_READ,
  ApiKeyScopes.SCHEDULING_EDIT,
  ApiKeyScopes.SCHEDULING_RERUN,
  ApiKeyScopes.BUDGETING_READ,
  ApiKeyScopes.BUDGETING_EDIT,
  ApiKeyScopes.BUDGETING_RERUN,
  ApiKeyScopes.COVERAGE_READ,
  ApiKeyScopes.COVERAGE_EDIT,
  ApiKeyScopes.COVERAGE_RERUN,
  ApiKeyScopes.WORKSPACE_READ,
  ApiKeyScopes.WORKSPACE_MEMBERS_READ,
  ApiKeyScopes.WORKSPACE_ACTIVITY_READ,
] as const satisfies readonly ApiKeyScopeValue[];
